/**
 * The router's route tree, handed to the Ask Dink panel (DNKADM-0434).
 *
 * `main.tsx` provides `appRoutes` here, beside the `RouterProvider`. The panel lives
 * inside `AppLayout`, which `router.tsx` itself imports, so reading `appRoutes` by
 * import would close a module cycle (router → AppLayout → panel → router); a context
 * value supplied at the root does not. Outside a provider the tree is empty, so the
 * panel sends an empty `routes` list and the server can offer no links.
 */
import { createContext } from 'react';
import type { RouteObject } from 'react-router-dom';

export const AskDinkRoutesContext = createContext<readonly RouteObject[]>([]);
